// apps/client/src/state/slices/fishing.ts (M1-T15) — keys start with "fishing" (§8.7 key rule)
import type { CatalogId } from '@whiskerton/content';
import type { ItemView } from '@whiskerton/shared';
import type { FishPhase } from '../../game/systems/fishing';
import type { SliceCreator } from '../types';
export interface FishingSlice {
  fishingPhase: FishPhase; fishingSetPhase(p: FishPhase): void;
  fishingCatch: { catalogId: CatalogId; size: number; item: ItemView } | null; fishingSetCatch(c: FishingSlice['fishingCatch']): void;
}
// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- declaration merging into GameStore
declare module '../types' { interface GameStore extends FishingSlice {} }
export const slice: SliceCreator<FishingSlice> = (set) => ({
  fishingPhase: 'idle', fishingSetPhase: (fishingPhase) => set({ fishingPhase }),
  fishingCatch: null, fishingSetCatch: (fishingCatch) => set({ fishingCatch }),
});
